module.exports = __webpack_public_path__ + "img/burned_teens.0a5e8392.jpeg";